import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const selectErrorState = (state: RootState) => state.error;

export const selectError = (actionType: string) => createSelector(
    [selectErrorState],
    (errorState) => errorState.errors[actionType]
);

export const selectErrorMessage = (actionType: string) => createSelector(
    [selectErrorState],
    (errorState) => errorState.errors[actionType]?.error?.errorMessage
);

export const selectErrorStatus = (actionType: string) => createSelector(
    [selectErrorState],
    (errorState) => errorState.errors[actionType]?.error?.statusCode
);

export const selectAllErrors = createSelector(
    [selectErrorState],
    (errorState) => errorState.errors
);

export const hasErrors = createSelector(
    [selectErrorState],
    (errorState) => Object.keys(errorState.errors).length > 0
);
